"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.profileUpdate = void 0;
const tslib_1 = require("tslib");
const axios_1 = require("axios");
const CryptoJS = require("crypto-js");
const helpers_1 = require("../chat/helpers");
const constants_1 = require("../constants");
const helpers_2 = require("../helpers");
const getUser_1 = require("./getUser");
const populateIUser_1 = require("../utils/populateIUser");
const progressHook_1 = require("../progressHook");
/**
 * Updation of profile
 */
const profileUpdate = (options) => tslib_1.__awaiter(void 0, void 0, void 0, function* () {
    const { pgpPrivateKey, account, profile, env = constants_1.default.ENV.PROD, progressHook, } = options || {};
    try {
        if (!(0, helpers_2.isValidETHAddress)(account)) {
            throw new Error(`Invalid account!`);
        }
        const user = yield (0, getUser_1.get)({ account, env });
        if (!user || !user.did) {
            throw new Error('User not Found!');
        }
        const updatedProfile = {
            name: profile.name ? profile.name : user.profile.name,
            desc: profile.desc ? profile.desc : user.profile.desc,
            picture: profile.picture ? profile.picture : user.profile.picture,
        };
        const hash = CryptoJS.SHA256(JSON.stringify(updatedProfile)).toString();
        const signature = yield (0, helpers_1.sign)({
            message: hash,
            signingKey: pgpPrivateKey,
        });
        const sigType = 'pgp';
        const verificationProof = `${sigType}:${signature}`;
        const body = Object.assign(Object.assign({}, updatedProfile), { verificationProof });
        const API_BASE_URL = (0, helpers_2.getAPIBaseUrls)(env);
        const apiEndpoint = `${API_BASE_URL}/v2/users/${user.did}/profile`;
        // Report Progress
        progressHook === null || progressHook === void 0 ? void 0 : progressHook(progressHook_1.default['PUSH-PROFILE-UPDATE-01']);
        const response = yield axios_1.default.put(apiEndpoint, body);
        if (response.data)
            response.data.publicKey = (0, helpers_2.verifyPGPPublicKey)(response.data.encryptedPrivateKey, response.data.publicKey, response.data.did);
        // Report Progress
        progressHook === null || progressHook === void 0 ? void 0 : progressHook(progressHook_1.default['PUSH-PROFILE-UPDATE-02']);
        return (0, populateIUser_1.populateDeprecatedUser)(response.data);
    }
    catch (err) {
        // Report Progress
        const errorProgressHook = progressHook_1.default['PUSH-ERROR-00'];
        progressHook === null || progressHook === void 0 ? void 0 : progressHook(errorProgressHook(exports.profileUpdate.name, err));
        throw Error(`[Push SDK] - API - Error - API ${exports.profileUpdate.name} -: ${err}`);
    }
});
exports.profileUpdate = profileUpdate;
//# sourceMappingURL=profile.updateUser.js.map